import $ from 'jquery';
import {component} from "@reduct/component";

import app from '../../assembler';

@component()
class SiteNavigation {
	constructor() {
		$(this.getElement()).navgoco({
			caretHtml: '',
			accordion: true,
			openClass: 'open',
			save: true,
			cookie: {
				name: 'navgoco',
				expires: false,
				path: '/'
			},
			slide: {
				duration: 400,
				easing: 'swing'
			},
			// Add Active class to clicked menu item
			onClickAfter: 'active_menu_cb'
		});
	}
}

app.register(SiteNavigation, 'SiteNavigation');
